import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface SciencePracticalAccessDialogProps {
  open: boolean;
  department?: string;
  onClose: () => void;
}

const SciencePracticalAccessDialog: React.FC<SciencePracticalAccessDialogProps> = ({
  open,
  department,
  onClose,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="science-practical-access-title"
    aria-describedby="science-practical-access-description"
  >
    <DialogTitle id="science-practical-access-title">Science practical access</DialogTitle>
    <DialogContent>
      <DialogContentText id="science-practical-access-description">
        Chemistry and Physics practicals are available only to students registered in the Science department.
        Your account is registered under {department || 'a non-Science department'}. This access is based on your department, not your selected subjects.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} variant="contained" autoFocus>
        Back to practicals
      </Button>
    </DialogActions>
  </Dialog>
);

export default SciencePracticalAccessDialog;
